import { Skeleton } from "@/shared/ui";

export default function LeaveApplicationsCardsSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mt-6">
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="flex flex-col gap-4 surface-component-fill radius-lg p-5">
          <div className="flex flex-col gap-2">
            <Skeleton width={100} height={24} borderRadius={6} />
            <Skeleton width={160} height={20} />
          </div>

          <div className="border-t surface-base-stroke" />

          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
              <Skeleton width={60} height={12} />
              <Skeleton width={120} height={24} borderRadius={6} />
            </div>

            <div className="flex flex-col gap-1.5">
              <Skeleton width={50} height={12} />
              <div className="flex items-center gap-1.5">
                <Skeleton width={16} height={16} borderRadius={4} />
                <Skeleton width={140} height={14} />
              </div>
            </div>

            <div className="flex flex-col gap-1.5">
              <Skeleton width={80} height={12} />
              <div className="flex items-center gap-1.5">
                <Skeleton width={16} height={16} borderRadius={4} />
                <Skeleton width={80} height={14} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
